import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import {LANGUAGE_FOR_OS} from './types';
import translationEn from './locales/translation.en';
import translationKo from './locales/translation.ko';
import translationJa from './locales/translation.ja.json'


const resources = {
    [LANGUAGE_FOR_OS.ko]: {
        translation: translationKo,
    }, [LANGUAGE_FOR_OS["ko-KR"]]: {
        translation: translationKo,
    }, [LANGUAGE_FOR_OS.EN]: {
        translation: translationEn,
    }, [LANGUAGE_FOR_OS.JA]: {
        translation: translationJa
    }
};


const init = () => {

    i18n
        .use(initReactI18next)
        .use(I18nextBrowserLanguageDetector)
        .init({
            initImmediate: false,
            resources: resources,
            fallbackLng: LANGUAGE_FOR_OS.EN,
            debug: false,
            defaultNS: 'translation',
            ns: 'translation', // keySeparator: '.', // we do not use keys in form messages.welcome
            keySeparator: '.',
            react: {
                useSuspense: false,
            },
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            detection: {
                order: ["querystring", "localStorage", "navigator"],
                lookupLocalStorage: process.env.REACT_APP_LANG_COOKIE,
                lookupQuerystring: "hl",
            },
        });
};

export default init;
